<div
  class="cb-input-wrapper"
  [class.cb-disabled]="disabled()"
  [class.cb-required]="required()"
  [class.cb-error]="error()"
>
  @if (label() || info()) {
    <div class="cb-input-label">
      @if (label()) {
        <label>{{ label() }}</label>
      }
      @if (info() && info()!.length > 0) {
        <cb-icon name="cb-base-outline-help"></cb-icon>
      }
    </div>
  }
  <div class="cb-input-container" [class.cb-buttons]="buttons()">
    @if (buttons() && buttonsType() == "divided") {
      <div class="cb-input-divided-button" (click)="decrement()">
        <cb-icon name="cb-base-outline-chevron-down"></cb-icon>
      </div>
    }
    @if (leadingText()) {
      <div class="cb-input-leading-text">
        <p>{{ leadingText() }}</p>
      </div>
    }
    <div
      class="cb-input"
      [class.cb-reset]="
        resetButton() &&
        displayedValue() !== undefined &&
        displayedValue() !== null
      "
    >
      @if (icon() || prefix()) {
        <div #Prefix class="cb-input-prefix">
          @if (icon()) {
            <cb-icon [name]="icon()!"></cb-icon>
          }
          @if (prefix()) {
            <p>{{ prefix() }}</p>
          }
        </div>
      }
      <input
        #Input
        type="text"
        inputmode="decimal"
        class="cb-input"
        [attr.id]="'input-number-' + label()"
        [attr.placeholder]="placeholder() ?? null"
        [value]="displayedValue()"
        [disabled]="disabled()"
        [required]="required()"
        (keydown)="onKeyDown($event)"
        (input)="onInput($event)"
        (blur)="onBlurHandler($event)"
        (keypress)="onInputKeyPress($event)"
      />

      @if (suffix()) {
        <div #Suffix class="cb-input-suffix">
          @if (suffix()) {
            <p class="cb-input-suffix">{{ suffix() }}</p>
          }
        </div>
      }
      @if (
        resetButton() &&
        displayedValue() !== undefined &&
        displayedValue() !== null
      ) {
        <div class="cb-input-reset-button-container" (click)="reset()">
          <div class="cb-input-reset-button">
            <cb-icon name="cb-base-outline-close"></cb-icon>
          </div>
        </div>
      }
    </div>
    @if (trailingText()) {
      <div class="cb-input-trailing-text">
        <p>{{ trailingText() }}</p>
      </div>
    }
    @if (buttons() && buttonsType() == "divided") {
      <div class="cb-input-divided-button" (click)="increment()">
        <cb-icon name="cb-base-outline-chevron-up"></cb-icon>
      </div>
    }
    @if (buttons() && buttonsType() == "trailing") {
      <div class="cb-input-trailing-buttons">
        <div class="cb-input-trailing-button" (click)="increment()">
          <cb-icon name="cb-base-outline-chevron-up"></cb-icon>
        </div>
        <div class="cb-input-trailing-button" (click)="decrement()">
          <cb-icon name="cb-base-outline-chevron-down"></cb-icon>
        </div>
      </div>
    }
  </div>
  @if (hint() && hint()!.length > 0) {
    <p class="cb-input-hint">{{ hint() }}</p>
  }
</div>
